import { runOnPage } from './general.js';

runOnPage('meet-the-team-default', () => {
	$(document).ready(function () {
		const $container = $('#image-container');
		let containerWidth = 0;
		let containerHeight = 0;
		let highestZIndex = 1;
		let cardsInitialized = false;

		function updateContainerSize() {
			containerWidth = $container.width();
			containerHeight = $container.height();
		}

		function updateStackOrder() {
			$container
				.children('.draggable')
				.each(function (i) {
					$(this).css('z-index', $container.children('.draggable').length - i);
				});
		}

		function centerNewTopCard() {
			const $newTop = $container.children('.draggable').first();
			if (!$newTop.length) return;

			const { width, height } = $newTop[0].getBoundingClientRect();
			const centerLeft = (containerWidth - width) / 2;
			const centerTop = (containerHeight - height) / 2;

			$newTop
				.css({ transition: 'none', left: centerLeft, top: centerTop, transform: 'rotate(0deg) scale(1)' });
			requestAnimationFrame(() => {
				$newTop.css('transition', 'all .4s ease-in-out');
			});
		}

		const isMobile = () => window.innerWidth <= 640;

		function initializeCards() {
			if (cardsInitialized) return;
			cardsInitialized = true;

			updateContainerSize();

			$(window).on('resize.aboutCards', () => {
				const wasMobile = isMobile();
				updateContainerSize();
				if (wasMobile !== isMobile()) {
					centerNewTopCard();
				}
			});

			$container.find('.draggable').each(function (index) {
				const $img = $(this);

				if (isMobile()) {
					setupMobileCard($img, index);
				} else {
					setupDesktopCard($img, index);
				}

				bindCommonHandlers($img);
			});
		}

		// ------------------ mobile ------------------
		function setupMobileCard($img, index) {
			const centerLeft = (containerWidth - $img.outerWidth()) / 2;
			const centerTop = (containerHeight - $img.outerHeight()) / 2;
			const final = {
				left:  centerLeft + (Math.random() - 0.5) * 40,
				top:   centerTop  + (Math.random() - 0.5) * 40,
				rot:   index === 0 ? 0 : Math.random() * 10 - 5,
				scale: index === 0 ? 1 : 0.85,
			};

			setTimeout(() => {
				$img.css({
					left:      final.left,
					top:       final.top,
					transform: `rotate(${final.rot}deg) scale(${final.scale})`,
					zIndex:    $container.children('.draggable').length - index,
				}).animate({ opacity: 1 }, 300);
			}, ($container.children('.draggable').length - index - 1) * 200);

			// swipe…
			$img.on('touchstart.aboutCards', function (e) {
				if (!$img.is($container.children('.draggable').first())) return;
				e.preventDefault();
				$img.css('transition', 'none');
				const touch0 = e.originalEvent.touches[0];
				const start = {
					left: parseFloat($img.css('left')) || 0,
					top:  parseFloat($img.css('top'))  || 0,
					x:    touch0.pageX,
					y:    touch0.pageY,
				};
				let moved = false, delta = { x: 0, y: 0 };

				function onMove(ev) {
					const t = ev.originalEvent.touches[0];
					delta = { x: t.pageX - start.x, y: t.pageY - start.y };
					if (Math.abs(delta.x) > 5 || Math.abs(delta.y) > 5) moved = true;
					$img.css({ left: start.left + delta.x, top: start.top + delta.y });
				}

				$(document)
					.on('touchmove.aboutCards', onMove)
					.one('touchend.aboutCards', () => {
						$(document).off('touchmove.aboutCards', onMove);
						if (!moved) return $img.css('transition', 'none');
						const dist = Math.hypot(delta.x, delta.y);
						const threshold = 0.2 * Math.hypot(containerWidth, containerHeight);

						if (dist > threshold) {
							const angle = Math.atan2(delta.y, delta.x);
							const target = {
								left: start.left + Math.cos(angle) * containerWidth * 2.5,
								top:  start.top  + Math.sin(angle) * containerHeight * 2.5,
							};
							$img.css({ transition: 'all .3s ease', ...target, opacity: 0 });
							setTimeout(() => {
								$img.appendTo($container).css({
									left:      final.left,
									top:       final.top,
									transform: `rotate(${final.rot}deg) scale(0.85)`,
									opacity:   1,
									transition:'none'
								});
								updateStackOrder();
								centerNewTopCard();
							}, 300);
						} else {
							$img.css({ left: final.left, top: final.top })
								.css('transform', index === 0
									? 'rotate(0deg) scale(1)'
									: `rotate(${final.rot}deg) scale(0.85)`);
						}
					});
			});
		}

		// ------------------ desktop ------------------
		function setupDesktopCard($img, index) {
			const rot = Math.random() * 10 - 5;
			const area = {
				left:   containerWidth * 0.10,
				top:    containerHeight * 0.10,
				width:  containerWidth * 0.75,
				height: containerHeight * 0.75
			};
			const final = {
				left: area.left + Math.random() * (area.width  - $img.outerWidth()),
				top:  area.top  + Math.random() * (area.height - $img.outerHeight())
			};
			const sides = [
				{ left: -$img.outerWidth() - 20, top: final.top },
				{ left: containerWidth + 20,    top: final.top },
				{ left: final.left,             top: -$img.outerHeight() - 20 },
				{ left: final.left,             top: containerHeight + 20 + $img.outerHeight() }
			];

			$img.css({
				...sides[Math.floor(Math.random() * 4)],
				opacity:   0,
				transform: `rotate(${rot}deg)`,
				position:  'absolute',
				transition: 'all 1.1s cubic-bezier(0.22, 1, 0.36, 1)'
			})
				.on('mouseenter', function () {
					$(this).css('z-index', ++highestZIndex);
				});

			setTimeout(() => {
				$img.css({
					left:       final.left,
					top:        final.top,
					opacity:    1,
					transform:  `rotate(${rot}deg)`
				});
			}, 600 + Math.random() * 1900);

			// drag&drop…
			$img.on('mousedown.aboutCards', function (e) {
				const rect = this.getBoundingClientRect();
				const shift = { x: e.clientX - rect.left, y: e.clientY - rect.top };
				$img.css('transition', 'none');

				function moveAt(pageX, pageY) {
					const cOff = $container.offset();
					$img.css({ left: pageX - shift.x - cOff.left, top: pageY - shift.y - cOff.top });
				}

				$(document)
					.on('mousemove.aboutCards', ev => moveAt(ev.pageX, ev.pageY))
					.one('mouseup.aboutCards', () => {
						$(document).off('mousemove.aboutCards');
						$img.css('transition', 'all .2s ease');
					});

				e.preventDefault();
			});
		}

		function bindCommonHandlers($img) {
			$img.on('dragstart.aboutCards', () => false);

			const $toggle  = $img.find('.info-toggle');
			const $infoBox = $img.find('.info-box');
			if ($toggle.length && $infoBox.length) {
				$toggle.on('click.aboutCards touchend.aboutCards', e => {
					e.preventDefault();
					$infoBox.toggleClass('hidden');
					$toggle.toggleClass('icon-question-mark-filled icon-minus');
				});
			}
		}

		if ('IntersectionObserver' in window) {
			new IntersectionObserver((entries, obs) => {
				if (entries[0].isIntersecting) {
					initializeCards();
					obs.disconnect();
				}
			}, { threshold: 0.1 })
				.observe($container[0]);

		} else {
			$(window).on('scroll.lazyCards', () => {
				if (!cardsInitialized &&
					$(window).scrollTop() + $(window).height() > $container.offset().top
				) {
					initializeCards();
					$(window).off('scroll.lazyCards');
				}
			});
		}

		document.querySelectorAll('video.video-thumb[preload][loop][playsinline]').forEach(video => {
			video.addEventListener('loadedmetadata', () => {
				video.currentTime = 0.001;
				video.pause();
			});
		});
	});
});
